import { render, staticRenderFns } from "./EditEmp.vue?vue&type=template&id=7a1afcb6&scoped=true&"
import script from "./EditEmp.vue?vue&type=script&lang=js&"
export * from "./EditEmp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a1afcb6",
  null
  
)

export default component.exports